import { useState, useContext } from 'react'
import { updateNotificationToAccepted, updateNotificationToRead } from '../services/notifications'
import { RootContext } from '../context/rootContext'

export const useUpdateNotification = () => {
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const { handleUpdateNotifications } = useContext(RootContext)
  const [loadingAcceptTerms, setLoadingAcceptTerms] = useState(false)

  const handleUpdateNotificationToRead = async (payLoad) => {
    try {
      payLoad.id = professional.id
      const notificationId = payLoad.notificationId
      const response = await updateNotificationToRead(payLoad)

      // atualiza state do context para manter o contador de avisos não lidos atualizados
      handleUpdateNotifications(notificationId, response)
    } catch (error) {
    }
  }

  const handleUpdateNotificationToAccepted = async (payLoad) => {
    try {
      setLoadingAcceptTerms(true)
      payLoad.id = professional.id
      const response = await updateNotificationToAccepted(payLoad)
      setLoadingAcceptTerms(false)
      if (response) {
        return response
      }
    } catch (error) {
    }
  }

  return {
    loadingAcceptTerms,
    handleUpdateNotificationToRead,
    handleUpdateNotificationToAccepted
  }
}
